module.exports = __webpack_public_path__ + "assets/img/coaching-cohort.3e8188bc.jpg";